export default class MonthOfYear {
    constructor(month, year) {
        this.month = month;
        this.year = year;
    }

    toString() {
        let month = this.month;
        if (month < 10) {
            month = `0${month}`;
        }

        return `${month}/${this.year}`;
    }

    next(steps) {
        steps = steps || 1;
        let addYears = Math.floor(steps / 12);
        const addMonths = steps % 12;
        if (this.month + addMonths > 12) {
            addYears++;
            return new MonthOfYear((this.month + addMonths) % 12, this.year + addYears);
        }
        return new MonthOfYear(this.month + addMonths, this.year + addYears);
    }

    prev(steps) {
        steps = steps || 1;
        let subtractYears = Math.floor(steps / 12);
        let subtractMonths = steps % 12;
        if (this.month - subtractMonths < 1) {
            subtractYears++;
            subtractMonths = subtractMonths - this.month;
        }
        return new MonthOfYear(this.month - subtractMonths, this.year - subtractYears);
    }

    isAfter(other) {
        return this.year > other.year || (this.year === other.year && this.month > other.month);
    }

    equals(other) {
        return other.month === this.month && other.year === this.year;
    }

    static current() {
        const today = new Date();
        return new MonthOfYear(today.getMonth() + 1, today.getFullYear());
    }

    static fromString(string) {
        if (!/^[1-3]\d{3}-(0[1-9]|1[0-2])$/.test(string)) {
            throw new Error(`${string} is not a valid format`);
        }

        const elements = string.split('-');
        const month = Number.parseInt(elements[1]);
        const year = Number.parseInt(elements[0]);

        return new MonthOfYear(month, year);
    }
}
